module.exports = __webpack_public_path__ + "img/logo.168872f8.png";